<template>
  <table v-if="singleView">
    <tr v-for="(value, index) in fields" :key="index">
      <th>{{ value.alias }}</th>
      <td>
        <span v-if="value.field === 'impact_transit' && data[value.field] === 'True'"><a href="http://www.brandontransit.ca/route-detours">See Transit Detours</a></span>
        <span v-else-if="value.field === 'opening_date' && data['open_date_approx'] !== ''"> {{ data['open_date_approx'] }} </span>
        <span v-else> {{ data[value.field] }} </span>
      </td>
    </tr>
  </table>
  <table v-else-if="data.error">
    <tr>
      <td>No current closures.</td>
    </tr>
  </table>
  <table v-else>
    <tr>
      <th v-for="(value, index) in fields" :key="index">{{ value.alias }}</th>
    </tr>
    <tr v-for="(datum, index) in data" :key="index">
      <td v-for="(value, index) in fields" :key="index">
        <span v-if="value.field === 'location'"><router-link :to="'/details/' + datum.id"> {{ datum.location }} </router-link></span>
        <span v-else-if="value.field === 'opening_date' && datum['open_date_approx'] !== ''"> {{ datum['open_date_approx'] }} </span>
        <span v-else v-html="value.map ? value.map[datum[value.field]] : datum[value.field]"></span>
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'ClosureTable',
  props: ['data', 'fields', 'singleView'],
  methods: {
    dataChange: function (val, oldVal) {
      if (this.singleView && val.id) {
        // this.$emit('send-location', val.location);
        this.$emit('send-location', val.id);
      } // if
    }
  },
  mounted: function () {
    
  },
  watch: {
    data: 'dataChange'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
